import { PartnerFields } from 'clickNgo/entities/partner/configs'

export const getLabelByExternalField = (field: string | number | symbol) => {
  const fields = Object.values(PartnerFields)
  return fields.find((item) => item.externalField === field)?.label
}
